import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2pz7ytgam: FaireProductEntity = {
  token: "p_v2pz7ytgam",
  type: "product",
  name: "Off Leash Set of Two Stitched Notebooks Journals",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/87fbc3191e474d4fb8e3a752ca761d26aa4b528a01ca0fdfab65fcb84cb1a1f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ead0e6d81a199f9fec87db7758f86fe7948c12ed19d242b401024e3a38fefe1b.jpeg",
    "https://cdn.faire.com/fastly/d441adaf611582f2da46dc3c21a83b9f027c0619de5ad7f8231301400fa135bc.jpeg",
    "https://cdn.faire.com/fastly/84c42db26451ae0922df5bacae441ebfba2c8aff68082f02fdbd2efc4df6e504.jpeg",
    "https://cdn.faire.com/fastly/4e13ed827e1d4728c6d257a420269566487add4c0f2de60cbc9beb478c465d59.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 8,
  description:
    "Who among us does not have an entire ocean of thoughts floating around in our heads? Nobody! A notebook is the perfect way to calm the cranial seas... simply write things down. And this set of 2 gives you so many options—make one messy, one clean. One to remember, one to forget. Likes, dislikes. Business in the front, party in the back. Have fun seeing what your thought waves will come up with.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:38.368Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
